export const formInputData = {
	id: '',
	placeholder: '',
	type: 'text',
	label: '',
	attribute_id: '',
};
